export const ROUTES = {
  home: "/",
  login: "/login",
  signup: "/signup",
  authCallback: "/auth/callback",
  onboarding: "/onboarding",
  dashboard: "/dashboard",
  card: "/dashboard/card",
  profile: "/dashboard/profile",
  assets: "/dashboard/assets",
  signature: "/dashboard/signature",
  background: "/dashboard/background",
  homeScreen: "/dashboard/home-screen",
  analytics: "/dashboard/analytics",
  settings: "/dashboard/settings",
  profileEditor: "/settings/profile",
};

export const NFC_DESIGNER_URL = "https://metworth-card-designer.rork.app";

export const authCallbackUrl = () => `${window.location.origin}${ROUTES.authCallback}`;
